import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import {
  ObjectConfigMappingCreateRequestDTO,
  ObjectConfigMappingUpdateRequestDTO,
  ObjectConfigMappingDeleteRequestDTO,
  ObjectConfigMappingReadByIdRequestDTO,
  ObjectConfigMappingReadByTenantIdRequestDTO,
  ObjectConfigMappingReadByObjectIdRequestDTO,
  ObjectConfigMappingDTO,
  ObjectConfigMappingList,
  ObjectConfigMappingReadByMenuIdRequestDTO,
  ObjectConfigMappingReadByMenuCodeRequestDTO,
  ObjectConfigMappingByMenuCodeList,
} from './ObjectConfigMapping.interface';

import {
  ObjectConfigMapping_Create,
  ObjectConfigMapping_Update,
  ObjectConfigMapping_ReadAll,
  ObjectConfigMapping_ReadById,
  ObjectConfigMapping_ReadByCompanyId,
  ObjectConfigMapping_ReadByObjectId,
  ObjectConfigMapping_Delete,
  ObjectConfigMapping_ReadByMenuId,
  ObjectConfigMapping_ReadByMenuCode
} from 'src/app/GlobalVariables';
import { resolveTenantUrl, tenantOverrideOptions } from 'src/app/Common/ApiConfigurationService/resolve-tenant-url.util';

@Injectable({
  providedIn: 'root'
})
export class ObjectConfigMappingService {

  constructor(private http: HttpClient) { }

  ObjectConfigMapping_create(data: ObjectConfigMappingCreateRequestDTO): Observable<ObjectConfigMappingDTO> {
    return this.http.post<ObjectConfigMappingDTO>(ObjectConfigMapping_Create, data);
  }

  ObjectConfigMapping_update(data: ObjectConfigMappingUpdateRequestDTO): Observable<ObjectConfigMappingDTO> {
    return this.http.post<ObjectConfigMappingDTO>(ObjectConfigMapping_Update, data);
  }

  ObjectConfigMapping_delete(data: ObjectConfigMappingDeleteRequestDTO): Observable<void> {
    return this.http.post<void>(ObjectConfigMapping_Delete, data);
  }

  ObjectConfigMapping_readAll(): Observable<ObjectConfigMappingList> {
    return this.http.get<ObjectConfigMappingList>(ObjectConfigMapping_ReadAll);
  }

  ObjectConfigMapping_readById(data: ObjectConfigMappingReadByIdRequestDTO): Observable<ObjectConfigMappingDTO> {
    return this.http.post<ObjectConfigMappingDTO>(ObjectConfigMapping_ReadById, data);
  }

  ObjectConfigMapping_readByCompanyId(data: ObjectConfigMappingReadByTenantIdRequestDTO): Observable<ObjectConfigMappingList> {
    return this.http.post<ObjectConfigMappingList>(ObjectConfigMapping_ReadByCompanyId, data);
  }

  ObjectConfigMapping_readByObjectId(data: ObjectConfigMappingReadByObjectIdRequestDTO): Observable<ObjectConfigMappingList> {
    return this.http.post<ObjectConfigMappingList>(ObjectConfigMapping_ReadByObjectId, data);
  }

  // baseUrlOverride (optional): the viewed tenant's own AM gateway origin,
  // e.g. CompanyDetailComponent.apiConfigOverride.AM (company-subroles tab ->
  // app-add-object-config). Omitted for every other caller - behaves exactly as before.
  ObjectConfigMapping_readByMenuId(data: ObjectConfigMappingReadByMenuIdRequestDTO, baseUrlOverride?: string, companyId?: string | number, branchId?: string | number): Observable<ObjectConfigMappingList> {
    return this.http.post<ObjectConfigMappingList>(resolveTenantUrl(ObjectConfigMapping_ReadByMenuId, baseUrlOverride), data, tenantOverrideOptions(baseUrlOverride, companyId ?? 0, branchId ?? 0));
  }

  ObjectConfigMapping_readByMenuCode(data: ObjectConfigMappingReadByMenuCodeRequestDTO): Observable<ObjectConfigMappingByMenuCodeList> {
     return this.http.post<ObjectConfigMappingByMenuCodeList>(ObjectConfigMapping_ReadByMenuCode, data);
  } 

}
